import dayjs from 'dayjs';
import storage from 'lib/utils/storage';
import { STORAGE } from 'lib/utils/storage/constants';
import { useEffect, useRef, useState } from 'react';

export const useCountDown = (key) => {
  const [countdown, setCountDown] = useState<number | null>(null);
  const intervalRef = useRef<number | null>();
  useEffect(() => {
    const sendTime = storage.getStorage(STORAGE.SMSCODE_SEND_TIME + key);
    if (!sendTime) {
      setCountDown(0);
      return;
    }
    const gapSeconds = dayjs(sendTime).diff(dayjs(), 'seconds');
    if (gapSeconds <= 0) {
      setCountDown(0);
      return;
    }
    startCountDown(gapSeconds);
    return () => restCountDown();
  }, []);

  useEffect(() => {
    if (countdown === null) return;
    if (Number(countdown) <= 0) {
      restCountDown();
      storage.removeStorage(STORAGE.SMSCODE_ORDER_ID + key);
      storage.removeStorage(STORAGE.SMSCODE_SEND_TIME + key);
      return;
    }
    if (intervalRef.current) return;
    intervalRef.current = window.setInterval(() => {
      setCountDown(c => Number(c) - 1);
    }, 1000);
    return () => restCountDown();
  }, [countdown]);

  const startCountDown = (time) => {
    setCountDown(time);
    const expireTime = dayjs().add(time, 'seconds')
      .valueOf();
    storage.setStorage(STORAGE.SMSCODE_SEND_TIME + key, expireTime, expireTime);
    return expireTime;
  };

  const restCountDown = () => {
    intervalRef.current && window.clearInterval(intervalRef.current);
    intervalRef.current = null;
  };

  return {
    countdown,
    startCountDown,
  };
};
